import React, { useState, useEffect } from 'react';
import { Cookie } from 'lucide-react';
import { Button } from './ui/button';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('crs_cookie_consent');
    if (!consent) {
      setTimeout(() => setShowBanner(true), 2000);
    }
  }, []);

  const handleAccept = () => {
    const visitor = {
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
      referrer: document.referrer,
      page: window.location.href
    };
    
    const visitors = JSON.parse(localStorage.getItem('crs_visitors') || '[]');
    visitors.push(visitor);
    localStorage.setItem('crs_visitors', JSON.stringify(visitors));
    localStorage.setItem('crs_cookie_consent', 'accepted');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4">
      <div className="container mx-auto">
        <div className="bg-white rounded-2xl shadow-2xl border-2 border-blue-200 p-6 max-w-4xl mx-auto">
          <div className="flex items-start space-x-4">
            <div className="flex-shrink-0">
              <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center shadow-lg">
                <Cookie className="w-6 h-6 text-white" />
              </div>
            </div>

            <div className="flex-1">
              <h3 className="text-xl font-black text-slate-900 mb-2">
                Essential Website Experience
              </h3>
              <p className="text-slate-600 mb-4 leading-relaxed">
                To provide you with the best experience and help us understand how to serve you better, we use essential cookies to track visitor analytics. 
                By continuing to use our website, you consent to our use of cookies.
                {' '}
                <a href="#" className="text-blue-500 hover:text-blue-600 font-semibold underline">
                  Learn more
                </a>
              </p>

              <Button
                onClick={handleAccept}
                className="bg-blue-500 hover:bg-blue-600 text-white px-8 py-3 rounded-xl font-bold shadow-lg hover:shadow-xl transition-all duration-300"
              >
                Accept & Continue
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;